/**
 * Add-to-cart helpers for Needed quiz (uses theme MicroBus cart when available).
 */
(function () {
  function parseProductHandle(url) {
    const match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function parseVariantFromUrl(url) {
    const match = String(url || '').match(/[?&]variant=(\d+)/);
    return match ? Number(match[1]) : null;
  }

  function resolveVariantId(url) {
    const fromUrl = parseVariantFromUrl(url);
    if (fromUrl) return fromUrl;
    const handle = parseProductHandle(url);
    if (!handle || !window.__quizProducts) return null;
    return window.__quizProducts[handle]?.variantId ?? null;
  }

  function resolveSellingPlanId(url) {
    const handle = parseProductHandle(url);
    const variantId = resolveVariantId(url);
    if (!variantId || !handle || !window.__quizProducts) return null;
    return window.__quizProducts[handle]?.variants[variantId]?.sellingPlanId ?? null;
  }

  async function addToCart(url) {
    const variantId = resolveVariantId(url);
    if (!variantId) {
      window.location.assign(url);
      return;
    }

    const sellingPlan = resolveSellingPlanId(url);
    const payload = {
      variant_id: variantId,
      quantity: 1,
      selling_plan: sellingPlan,
      disableCartToggle: false,
    };

    if (window.MicroBus) {
      window.MicroBus.emit('cart:add', payload);
      return;
    }

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const item = { id: variantId, quantity: 1 };
    if (sellingPlan) item.selling_plan = sellingPlan;

    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [item] }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to cart');
    }

    document.querySelector('cart-drawer')?.open?.();
  }

  function createButton({ className, text, url, busyText, doneText }) {
    const btn = document.createElement('button');
    btn.type = 'button';
    if (className) btn.className = className;
    btn.textContent = text;

    btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = busyText || 'Adding…';
      try {
        await addToCart(url);
        btn.textContent = doneText || 'Added ✓';
        setTimeout(() => {
          btn.textContent = label;
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        console.error('[needed-quiz] add to cart failed:', err);
        btn.textContent = label;
        btn.disabled = false;
      }
    });

    return btn;
  }

  window.NeededQuizCart = {
    addToCart,
    createButton,
    resolveVariantId,
  };

  /** @deprecated Use NeededQuizCart.createButton — kept for variant merchandising snippets */
  window.quizAtc = function (className, text, url) {
    return createButton({ className, text, url });
  };
})();
